export function addDropdownFilterToUrlParams() {
    this.filters.forEach(filter => {
        filter.options.forEach(filterOption => {
            const searchParam = `${filter.id}`;
            if (filterOption.type === 'tags' || filterOption.type === 'tagSearch') {
                const listOfChecks = filterOption.options
                    .filter(check => check.value)
                    .map(check => check.id);
                this.filterParams[searchParam] = listOfChecks.length > 0 ? listOfChecks : null;
            } else if (filterOption.type === 'textSearch' && filterOption.value !== '') {
                this.filterParams[searchParam] = filterOption.value;
            } else if (
                (filterOption.type === 'minMaxString' || filterOption.type === 'minMaxCombo') &&
                (filterOption.min !== '' || filterOption.max !== '')
            ) {
                this.filterParams[searchParam] = `${filterOption.min},${filterOption.max}`;
            } else {
                this.filterParams[searchParam] = null;
            }
        });
    });
}

export function sortCompareFunction() {
    return !this.sortBy.key
        ? (firmwareA, firmwareB) =>
              firmwareB.createdAt.toString().localeCompare(firmwareA.createdAt.toString())
        : (firmwareA, firmwareB) =>
              firmwareA[this.sortBy.key]
                  .toString()
                  .localeCompare(firmwareB[this.sortBy.key].toString()) *
              (this.sortBy.order === 'ascending' ? 1 : -1);
}

export function updateUrlSearch() {
    const newParams = new URLSearchParams(window.location.search);
    for (let param in this.initializers) {
        if (!this.filterParams[param]) {
            newParams.delete(param);
            continue;
        }
        newParams.set(param, this.filterParams[param]);
    }
    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    window.history.pushState({}, '', newUrl);
    this.onFiltersChanged(new URLSearchParams(window.location.search));
}
